module.exports = __webpack_public_path__ + "img/312.a9ae1f91.png";